import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useWebServer } from "../../../../providers";
import { loadSpeciesRanking } from "../../../../actions";
import { buildSpeciesColorScale } from "../../../../utils/chartPalette";

/**
 * The organization's species color scale ({colorOf, isOther}), loading the
 * all-time species ranking it is built from once per organization, while
 * `enabled`. Until it arrives each chart ranks its own species, and repaints
 * once.
 */
export const useSpeciesColors = (enabled = true) => {
  const dispatch = useDispatch();
  const { sendOrganizationRequest } = useWebServer();
  const organization = useSelector((state) => state.user?.organization);
  const ranking = useSelector((state) => state.report?.speciesRanking);

  const current = ranking?.organization === organization;
  useEffect(() => {
    if (enabled && organization && !current && sendOrganizationRequest) {
      dispatch(loadSpeciesRanking(sendOrganizationRequest, organization));
    }
    // sendOrganizationRequest is rebuilt whenever the provider renders; the
    // ranking depends only on the organization
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enabled, organization, current]);

  const labels = current ? ranking.labels : null;
  return useMemo(() => buildSpeciesColorScale(labels ?? []), [labels]);
};
